import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./components/App.js";

// styles
import "./assets/css/index.css";
import "./assets/css/light.css";
import "./assets/css/dark.css";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";

// cookies
import { CookiesProvider } from "react-cookie";
// multi language
import global_ar from "./assets/translations/ar/globals.json";
import global_en from "./assets/translations/en/globals.json";

import i18next from "i18next";
import { I18nextProvider } from "react-i18next";
i18next.init({
    interpolation: { escapeValue: true },
    lng: "ar",
    resources: {
        ar: {
            global: global_ar
        },
        en: {
            global: global_en
        }
    }
});

// import { store } from "./redux/store";
// import { Provider } from "react-redux";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    // <React.StrictMode>
    // <Provider store={store}>
    <I18nextProvider i18n={i18next}>
        <CookiesProvider defaultSetOptions={{ path: "/" }}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </CookiesProvider>
    </I18nextProvider>
    // </Provider>
    // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
